export function parseJwt(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const payload = JSON.parse(atob(base64));

  const roleRaw = payload['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] ?? '';
  const permRaw = payload['Permissions'] ?? '';
  const orgRaw  = payload['Organizations'] ?? '';

  return {
    authType:         payload['AuthType'] ?? '',
    username:         payload['Username'] ?? '',
    email:            payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'] ?? '',
    sessionId:        payload['SessionId'] ?? '',
    userId:           payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'] ?? '',
    name:             payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'] ?? '',
    isEmailConfirmed: payload['IsEmailConfirmed'] === 'True',
    roles:            roleRaw ? roleRaw.split(';').filter(Boolean) : [],
    permissions:      permRaw ? permRaw.split(';').filter(Boolean) : [],
    organizations:    orgRaw  ? orgRaw.split(';').filter(Boolean)  : [],
    exp:              payload['exp'],
  };
}

export function isTokenExpired(exp) {
  return Date.now() >= exp * 1000;
}
